import { Gender } from "../graphql/types/global";
import { validatePassword } from "../global";
import { validateEmail } from "./validators";

export const validateFormElement = (
  name: string,
  value: string,
  nominationError?: boolean
): string => {
  let validationError = "";

  switch (name) {
    case "firstName":
      if (value.trim().length === 0) {
        validationError = nominationError
          ? "You must tell us your first name."
          : "Please enter your first name. Do not include middle names.";
      }
      break;
    case "lastName":
      if (value.trim().length === 0) {
        validationError = nominationError
          ? "You must tell us your last name."
          : "Please enter your last name.";
      }
      break;
    case "email":
      const validatedEmail = validateEmail(value);
      if (validatedEmail) {
        validationError = validatedEmail;
      }
      break;
    case "phone":
      if (
        value.trim() !== "" &&
        value
          .replace(/ /g, "")
          .match(/((\+44(\s\(0\)\s|\s0\s|\s)?)|0)7\d{3}(\s)?\d{6}/) === null
      ) {
        validationError =
          "Please enter a valid UK mobile number e.g. 0774 123 4567";
      }
      break;
    case "addressLine1":
      if (value.trim().length <= 1) {
        validationError = "Please enter a valid first line";
      }
      break;
    case "addressCity":
      if (value.trim().length === 0) {
        validationError = "Please enter the city";
      }
      break;
    case "addressPostcode":
      const length = value.replace(/\s+/g, "").length;

      if (length > 7 || length < 5) {
        validationError = nominationError
          ? "You must tell us your home address"
          : "Please enter a valid postcode.";
      }

      if (length === 0) {
        validationError = "Please enter your postcode.";
      }

      break;
    case "password":
      const validatedPassword = validatePassword(value);
      if (validatedPassword) {
        validationError = validatedPassword;
      }
      break;
    case "linkageKey":
      if (value.trim().length === 0) {
        validationError = "Linkage key";
      }
      break;
    case "accountID":
      if (value.trim().length === 0) {
        validationError = "Account ID";
      }
      break;
    case "odsCode":
      if (value.trim().length === 0) {
        validationError = "ODS Code";
      }
      break;
    default:
      break;
  }
  return validationError;
};

type GenderUnion =
  | Gender.GENDER_FEMALE
  | Gender.GENDER_MALE
  | Gender.GENDER_OTHER;

export const genderOptionsDeprecated: {
  [key in GenderUnion]: {
    description: string;
  };
} = {
  [Gender.GENDER_FEMALE]: {
    description: "Female"
  },
  [Gender.GENDER_MALE]: {
    description: "Male"
  },
  [Gender.GENDER_OTHER]: {
    description: "Non-binary/third gender"
  }
};

export const genderOptions = [
  {
    label: "Female",
    value: Gender.GENDER_FEMALE
  },
  {
    label: "Male",
    value: Gender.GENDER_MALE
  },
  {
    label: "Non-binary/third gender",
    value: Gender.GENDER_OTHER
  }
];
